
import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component({
      name: 'InputGroup'
    })
export default class InputGroup extends Vue {
        @Prop() id!: string;
        @Prop() items!: { label: 'string', value: number}[];
        @Prop({ default: '' }) name!: string;
        @Prop({ default: '' }) label!: string;
        @Prop({ default: '' }) subLabel!: string;
        @Prop({ default: false }) columns!: boolean;
        @Prop() value!: number;

        setValue (val: number) {
          this.$emit('update', val)
        }
}
